<script lang="ts" setup></script>

<template>FEDERATION</template>
